// Copyright (c) 2017 Deere & Company

import 'frozen-moment';
import moment from 'moment';

export const buildMoment = timestamp => timestamp ? moment.utc(timestamp).freeze() : null;



// WEBPACK FOOTER //
// ./src/shared/services/build-moment.js